import React, { useState, useEffect } from 'react'
import { Pane, Switch, TextInputField, Text, toaster } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault';
import { connect } from 'react-redux'
import { setLoading, unsetLoading } from '../../Redux/reducers/loading';
import axios from '../../Utils/axios';
const ResourcesForm = ({
  close, company, dispatch, edit
}) => {

  const [formValues, setFormValues] = useState({
    name: '',
    active: true,
    requiresMileage: true
  })

  const [isEdit, setEdit] = useState(false)

  useEffect(() => {
    if (edit) {
      setFormValues(edit)
      setEdit(true)
    }
  }, [edit])

  const handleEdit = async () => {
    dispatch(setLoading())
    try {
      await axios.put(`/company/resources/${edit.__id__}`,
        formValues
      )

      close(null)
    } catch (error) {
      toaster.danger('Falha ao editar o recurso')
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  const handleCreate = async () => {

    dispatch(setLoading())
    try {
      const { data } = await axios.post(`/company/resources`,
        formValues
      )
      toaster.success('Recurso salvo com sucesso')
      close(data)
    }
    catch (error) {
      toaster.danger('Falha ao salvar o recurso')
    }
    finally {
      dispatch(unsetLoading())
    }
  }



  return (
    <React.Fragment>
      <Pane flex={1} alignItems="center" marginTop={10}>
        <TextInputField
          label='Descrição do Recurso'
          description=""
          name='name' placeholder='Descrição' value={formValues.name}
          onChange={({ target }) => {
            setFormValues({
              ...formValues,
              [target.name]: target.value
            })
          }} />
        <Text>
          Ativo
          <Switch
            name='active'
            height={24}
            checked={formValues.active}
            onChange={({ target }) => setFormValues({
              ...formValues,
              [target.name]: target.checked
            })}
            marginBottom={16}
          />
        </Text>
        <Text>
          Requer km
          <Switch
            name='requiresMileage'
            height={24}
            checked={formValues.requiresMileage}
            onChange={({ target }) => {
              setFormValues({ ...formValues, [target.name]: target.checked })
            }}
            marginBottom={16}
          />
        </Text>
        <BtnDefault
          disabled={!formValues.name}
          onClick={() => {

            if (!edit) {
              handleCreate()
            }
            else {
              handleEdit()
            }

          }}
          iconBefore='tick'
          height={40} appearance="primary">
          {!isEdit ? 'Cadastrar' : 'Editar'}
        </BtnDefault>
      </Pane>
    </React.Fragment>
  )

}

const mapStateToProps = ({ auth }) => ({ company: auth.account })

export default connect(mapStateToProps)(ResourcesForm)